//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Konva from 'konva';
import "ant-design-vue/es/tooltip/style/index.css"
import { blobToBase64, computeRenderIconOfProp, humanReadablePropValue } from "@/utils/converter";
import { indexOfMin } from "@/utils/helpers";
import { v4 as uuidv4 } from 'uuid';
import Vue from "vue"
import WorkAreaWidget from "@/components/objects/WorkAreaWidget";
import { lineString, point, points } from "@turf/helpers";
import polylabel from "@mapbox/polylabel"
import center from "@turf/center"
import nearestPointOnLine from "@turf/nearest-point-on-line"
import IconView from "@/components/objects/IconView.vue";
import AsyncObjectSnippetTooltip from "@/components/AsyncObjectSnippetTooltip.vue";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import ThePopover from "@/components/objects/public/ThePopover.vue";
import { addServerPath } from "@/plugins/add-server-path";
import { STORAGE_BACKGROUND_PATH, BUILD_GENERAL_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { hexToRgb } from "@/utils/helpers.js";
import cloneDeep from "lodash/cloneDeep"

const debounce = require("lodash/debounce")

const getMidPointOfObject = (obj, ceil = false) => {
  const coords = obj.anchors.map(item => [item.attrs.x, item.attrs.y])
  const toResult = (coords) => {
    if (ceil) return [Math.ceil(coords[0]), Math.ceil(coords[1])]
    return coords
  }

  if (obj.type === "line") {
    let features = points(coords)
    const nearestPoint = nearestPointOnLine(
      lineString(coords),
      point(center(features).geometry.coordinates)
    );

    return toResult(nearestPoint.geometry.coordinates)
  } else {
    return toResult(polylabel([coords]))
  }
}

export default {
  name: "MapSchemeView",
  components: {
    // ThePopover,
    // TheSwitch,
    IconView,
    // WorkAreaWidget,
  },
  provide: {
    source: 'objScheme'
  },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String
    },
    fetchImagePath: {
      type: String,
      default: '/public/object_images_files/$id/'
    },
    imageUrl: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      loaded: false,
      loading: false,
      stage: null,
      sceneWidth: this.data.polygons.coordinates.width || 837,
      polygonsLayer: null,
      imageLayer: null,
      anchorsLayer: null,
      objects: [],
      anchorImagePath: null,
      legendListActive: '',
      tooltip: null,
      initialWidth: 0,
      planner: [],
      topOffset: 0,
      bottomOffset: 0,
      labelHeight: 0,
      renderDots: [],
      renderUUID: "",
      plannerLayer: null,
      dotsReq: '',
      planerOptions: {
        width: 0,
        height: 0,
        x_spacing: 0,
        y_spacing: 0,
        padding: 5,
        mode: 1
      },
      lineIsFetching: false,
      backgroundLayer: null,
      imageData: null,
      windowWidth: 0,
      activePolygonId: '',
      highlightPolygonId: '',
    }
  },
  computed: {
    sceneHeight() {
      return Math.ceil(this.sceneWidth / this.data.polygons.aspectRatio);
    },
    computedStyle() {
      return {
        //'aspect-ratio': this.data.polygons.aspectRatio,
        'min-height': this.loaded ? '0px' : `${this.initialWidth / this.data.polygons.aspectRatio}px`
      }
    },
    isStaging() {
      return process.env.isStaging
    },
    humanReadableSourceCopyright() {
      try {
        if (this.data.image_url) {
          return `${new URL(this.data.image_url).origin}`
        }
      } catch {
      }

      return ''
    },
  },
  mounted() {
    this.renderUUID = uuidv4()

    if (this.loading || this.loaded) return
    this.initialWidth = this.$refs.workAreaView.offsetWidth
    const uuid = uuidv4();
    const newElement = document.createElement('div')
    newElement.id = uuid
    this.$refs.canvas.appendChild(newElement)

    this.stage = new Konva.Stage({
      container: uuid
    })
    this.init()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    this.closeTooltipBeforeOpenNew()
  },
  methods: {
    createLayer() {
      return new Konva.Layer({})
    },
    closeTooltipBeforeOpenNew() {
      if (this.tooltip) this.tooltip.$destroy();
    },
    /**
     * @param {Object|String} targetObject
     */
    showPolygons(targetObject) {
      this.closeTooltipBeforeOpenNew()
      const afterCloseCallback = () => {
        this.polygonsLayer.children.filter(x => x.id() === targetObject.id).forEach(x => x.setAttrs({
          opacity: 0,
          opened: false
        }))
        this.anchorsLayer
          .find(node => {
            return node.attrs.object_id === targetObject.id
          })
          .forEach(node => {
            node.setAttrs({ visible: true, opened: false })
          })
      }
      return new Promise((resolve, reject) => {
        if (Array.isArray(targetObject)) return reject('Активным может быть только один полигон')
        if (typeof targetObject === "string") targetObject = { id: targetObject }

        if (targetObject.id === this.activePolygonId) {
          this.activePolygonId = ""
          this.highlightPolygonId = ""
          afterCloseCallback()
          return
        }

        this.activePolygonId = targetObject.id
        const object = this.findObjectById(targetObject.id)

        const coords = object.anchors.map(item => [item.attrs.x, item.attrs.y])
        const midPoint = getMidPointOfObject(object, true)
        this.updateDottedLines(object.id, true, true)
        let offset = {
          x: 0,
          y: 0
        }

        if (object.type === "point" || object.type === "line") {
          offset.x = midPoint[0]
          offset.y = midPoint[1]
        } else if (object.type === "polygon" || object.type === "rect") {
          // const maxPos = coords[indexOfMin(coords.map(x => x[1]))]

          offset.x = midPoint[0]
          offset.y = midPoint[1]
          // offset.x = maxPos[0]
          // offset.y = maxPos[1]
        }

        if (object.description?.object) {
          this.createTooltip(
            {
              offset: {
                x: offset.x,
                y: offset.y + (this.topOffset / this.getStageScale()) - 10
              }
            },
            object
          )
            .then(() => {
              if (targetObject.id === this.activePolygonId) {
                this.activePolygonId = ""
                this.highlightPolygonId = ""
              }

              afterCloseCallback()

              resolve()
            })

          // Скрытие связанных с полигоном элементов
          const group = this.anchorsLayer.children.find(x => x.getAttr('object_id') === object.id)
          group.setAttrs({ opened: true, visible: false })
          group.children[0].setAttr('radius', 7)
          group.children[1].setAttr('radius', 6)

          if (document.getElementById(`legend-${object.id}`)) {
            document.getElementById(`legend-${object.id}`).style.display = 'none'
          }
        }
      })
    },
    drawImage(src) {
      const layer = this.createLayer();
      const imageObj = new Image();
      imageObj.src = src;
      const scale = this.sceneWidth / this.data.polygons.coordinates.width;

      const image = new Konva.Image({
        image: imageObj,
        x: 0,
        y: 0,
        width: this.data.polygons.coordinates.width,
        height: this.data.polygons.coordinates.height,
        type: 'image',
        preventDefault: false
      });

      this.imageLayer = new Konva.Group({
        x: image.x(),
        y: this.topOffset,
        scaleX: scale,
        scaleY: scale,
      });

      const topGradient = new Konva.Rect({
        width: image.width(),
        height: 20,
        y: 0,
        fillLinearGradientStartPoint: { x: 0, y: 0 },
        fillLinearGradientEndPoint: { x: 0, y: 20 },
        fillLinearGradientColorStops: [0, 'rgba(249, 254, 255, .6)', 1, 'rgba(249, 254, 255, 0)'],
        listening: false,
      });

      const bottomGradient = new Konva.Rect({
        y: image.height() - 19,
        width: image.width(),
        height: 20,
        fillLinearGradientStartPoint: { x: 0, y: 0 },
        fillLinearGradientEndPoint: { x: 0, y: 20 },
        fillLinearGradientColorStops: [0, 'rgba(249, 254, 255, 0)', 1, 'rgba(249, 254, 255, .6)'],
        listening: false,
      });

      this.imageLayer.add(image, topGradient, bottomGradient);
      layer.add(this.imageLayer);
      this.stage.add(layer);

      layer.draw();
      this.imageLayer.on('tap', () => {
        this.closeTooltipBeforeOpenNew()
        this.polygonsLayer.children
          .filter(x => {
            return !x.getAttr('opened') && x.getAttr('opacity') === 1
          })
          .forEach(x => {
            x.setAttr('opacity', 0)
          })
      })
    },
    getImageData: async function () {
      const response = await this.$axios.get(this.fetchImagePath.replace('$id', this.data.id), {
        responseType: 'blob',
      });
      return Promise.resolve(blobToBase64(response.data))
    },
    getStageScale() {
      return this.$refs.canvas.offsetWidth / this.sceneWidth;
    },
    setStageSize(resetOffset = false) {
      const scale = this.getStageScale()

      this.stage.setAttrs({
        width: this.sceneWidth * scale,
        height: this.sceneHeight * scale + (this.topOffset + this.bottomOffset),
        scale: { x: scale, y: scale }
      })

      if (resetOffset) {
        this.imageLayer.setAttr('y', 0)
        this.polygonsLayer.setAttr('y', 0)
        this.anchorsLayer.setAttr('y', 0)
      }
    },
    findObjectById(id) {
      return this.objects.find(x => x.id === id);
    },
    updateDottedLines(id, visible = false, opened = null) {
      let linePath = this.polygonsLayer.findOne(`#${id}`);
      const object = this.findObjectById(id);
      const coords = object.anchors.map(x => x.attrs)

      if (!linePath) {
        linePath = new Konva.Line({
          strokeWidth: 2,
          stroke: '#328FE6',
          fill: 'rgba(50, 143, 229, 0.2)',
          lineCap: 'round',
          polygon_id: id,
          id: id,
          type: 'polygon',
          hitStrokeWidth: object.type === 'line' ? 10 : 0,
          points: coords.map(el => [el.x, el.y]).flat(),
          closed: object.type !== 'line',
          opacity: 0,
          opened: false
        });

        this.polygonsLayer.add(linePath);

        linePath.on('mouseenter', () => {
          linePath.setAttr('opacity', 1)
          this.highlightPolygonId = id
        })

        linePath.on('mouseleave', () => {
          if (!linePath.getAttr('opened')) linePath.setAttr('opacity', 0)
          this.highlightPolygonId = ""
        })

        linePath.on('click', () => {
          this.anchorsLayer.children.find(x => x.attrs.object_id === id).dispatchEvent(new Event('click'))
          this.highlightPolygonId = ""
        })

        const ctx = this
        linePath.on('tap', (event) => {
          this.closeTooltipBeforeOpenNew()

          if (linePath.getAttr('opacity') === 0) {
            linePath.setAttr('opacity', 1)
            this.highlightPolygonId = id
            ctx.polygonsLayer.children.filter(x => x.attrs.polygon_id !== id).map(x => x.setAttr('opacity', 0))
          } else if (linePath.getAttr('opacity') === 1) {
            event.evt.stopPropagation()
            ctx.anchorsLayer.children.find(x => x.attrs.object_id === id).dispatchEvent(new Event('click'))
          }
        })
      }

      linePath.setAttr('opacity', visible ? 1 : 0)
      if (visible) {
        this.highlightPolygonId = id
      } else {
        this.highlightPolygonId = ""
      }
      if (typeof opened === 'boolean') linePath.setAttr('opened', opened)

      return linePath
    },
    buildPreviewsAnchors(id) {
      const object = this.findObjectById(id);
      const midPoint = getMidPointOfObject(object, true)

      this.renderDots.push({
        midPoint: midPoint,
        object: object.description.object,
        id: object.id,
        plannerCenter: `${midPoint[0]}x${midPoint[1]}`
      })

      const group = new Konva.Group({
        x: midPoint[0],
        y: midPoint[1],
        width: 30,
        height: 30,
        offsetX: 15,
        offsetY: 15,
        scale: { x: 1, y: 1 },
        opened: false,
        object_id: id,
        preventDefault: false
      })

      const border = new Konva.Circle({
        radius: 7,
        fill: 'transparent',
        stroke: '#fff',
        strokeWidth: 2,
        opacity: .5,
        x: group.width() / 2,
        Y: group.height() / 2,
        preventDefault: false,
        hitStrokeWidth: window.innerWidth > 768 ? 0 : 20
      })

      const center = new Konva.Circle({
        radius: 6,
        fill: '#fff',
        strokeWidth: 2,
        stroke: '#000',
        opacity: .5,
        x: group.width() / 2,
        Y: group.height() / 2,
        preventDefault: false,
      })

      const dot = new Konva.Circle({
        radius: 1,
        fill: '#000',
        opacity: .5,
        strokeEnabled: false,
        x: group.width() / 2,
        Y: group.height() / 2,
        preventDefault: false,
      })

      group.add(border, center, dot)

      this.anchorsLayer.add(group)

      group.on('mouseover', (event) => {
        this.stage.container().style.cursor = 'pointer';
        if (event.currentTarget.attrs.opened) return
        border.setAttr('radius', 12)
        center.setAttr('radius', 10)
        this.updateDottedLines(id, true)
      })
      group.on('mouseout', (event) => {
        this.stage.container().style.cursor = 'default';
        if (event.currentTarget.attrs.opened) return
        border.setAttr('radius', 7)
        center.setAttr('radius', 6)
        this.updateDottedLines(id, false)
      })
      group.on('click tap', () => {
        this.showPolygons(object).then(() => {
          group.setAttrs({
            'opened': false,
            'visible': true
          })
          this.updateDottedLines(object.id, false, false);

          if (document.getElementById(`legend-${group.attrs.object_id}`)) {
            document.getElementById(`legend-${group.attrs.object_id}`).style.display = 'block'
          }
        })
      })
    },
    handleResize: debounce(function () {
      if (this.lineIsFetching) return
      if (window.innerWidth === this.windowWidth) return;
      this.windowWidth = window.innerWidth
      this.lineIsFetching = true
      this.topOffset = 0
      this.bottomOffset = 0
      this.setStageSize(true)
      const scale = this.getStageScale()
      if (this.plannerLayer !== null) {
        this.plannerLayer.removeChildren()
        this.plannerLayer.remove()
        this.plannerLayer = null
      }
      if (this.data.label) {
        this.labelHeight = Math.abs(this.$refs.labelOfPicture.clientHeight + 20)
      }
      this.fetchLines()
        .then((planner) => {
          this.planner = planner
          this.drawLines()
          this.imageLayer.setAttr('y', this.topOffset / scale)
          this.polygonsLayer.setAttr('y', this.topOffset / scale)
          this.anchorsLayer.setAttr('y', this.topOffset / scale)
          this.setStageSize()
          this.drawBackground()
          this.renderUUID = uuidv4()
          this.$emit('ready')
          this.lineIsFetching = false
        })

    }, 500),
    init: async function () {
      this.setStageSize();
      this.loading = true
      this.windowWidth = window.innerWidth

      this.imageData = this.imageUrl
      this.drawImage(this.imageData)

      const scale = this.getStageScale()
      this.anchorsLayer = this.createLayer();
      this.polygonsLayer = this.createLayer();
      this.stage.add(this.polygonsLayer);
      this.stage.add(this.anchorsLayer);

      this.data.polygons.polygons.forEach(x => {
        x.line = null
        this.objects.push(x)
        if (x.description.object) {
          this.buildPreviewsAnchors(x.id);
          this.updateDottedLines(x.id, false, false)
        }
      })
      if (this.data.label) {
        this.labelHeight = Math.abs(this.$refs.labelOfPicture.clientHeight + 20)
      }

      this.planner = await this.fetchLines()
      if (this.planner.length) {
        this.drawLines()
      } else {
        this.bottomOffset = this.labelHeight
      }

      this.loading = false;
      this.loaded = true
      this.imageLayer.setAttr('y', this.topOffset / scale)
      this.polygonsLayer.setAttr('y', this.topOffset / scale)
      this.anchorsLayer.setAttr('y', this.topOffset / scale)
      this.setStageSize();
      this.drawBackground()
      this.$emit('ready')

      window.addEventListener('resize', this.handleResize, { passive: true })
    },
    async createTooltip(options, obj) {
      const scale = this.$refs.canvas.clientWidth / this.sceneWidth;

      //const ComponentClass = this.$nuxt.$options.components.AsyncObjectSnippetTooltip
      const ComponentClass = Vue.extend(AsyncObjectSnippetTooltip)

      const instance = await new ComponentClass({
        propsData: {
          vistatObject: {
            ...obj.description.object,
            text: obj.description.text || obj.description.object.text
          },
        },
        provide: {
          source: 'objScheme'
        },
        store: this.$store,
      })

      const slotContent = new Vue({
        data() {
          return {
            options: {
              offset: {
                x: options.offset.x,
                y: options.offset.y,
              },
            },
            scale: scale,
          };
        },
        template: `
          <div class="silent-tooltip-marker"></div>`,
      }).$mount()

      return new Promise((resolve, reject) => {
        const destroy = () => {
          //targetEl.remove();
          instance.$destroy();
          resolve()
          this.tooltip = null
        }

        instance.$on('update:open', (visible) => {
          if (!visible) {
            destroy()
          }
        })
        this.tooltip = instance
        instance.$slots.default = [slotContent._vnode];

        instance.$mount()
        if (window.innerWidth < Math.round(options.offset.x * scale) + 20) {
          instance.$el.style.left = `${Math.round(options.offset.x * scale) - 10 - (Math.round(options.offset.x * scale) + 20 - window.innerWidth)}px`
        } else {
          instance.$el.style.left = `${Math.round(options.offset.x * scale) - 10}px`
        }
        instance.$el.style.top = `${Math.round(options.offset.y * scale)}px`
        instance.$el.style.width = `20px`
        instance.$el.style.height = `10px`
        instance.$el.style.position = 'absolute'

        this.$refs.canvas.appendChild(instance.$el)

        instance.manuallyOpen()

        function elementInViewport(el) {
          const bounding = el.getBoundingClientRect();

          if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
            return true
          } else {
            return false
          }
        }

        setTimeout(() => {
          if (!elementInViewport(instance.$el)) {
            instance.$el.scrollIntoView({ block: "nearest", behavior: "smooth" });
          }
        }, 100)
      })
    },
    async fetchLines() {
      const scale = this.getStageScale()

      const w = Math.ceil(this.sceneWidth * scale)
      const h = Math.ceil(w / this.data.polygons.aspectRatio)

      const anchors = new Map()

      const dots = this.anchorsLayer.children.map(x => {
        const posAbs = x.absolutePosition()
        const pos = x.position()
        anchors.set(`${Math.ceil(posAbs.x)}x${Math.ceil(h - posAbs.y)}`, `${Math.ceil(pos.x)}x${Math.ceil(pos.y)}`)
        return `${Math.ceil(posAbs.x)},${Math.ceil(h - posAbs.y)}`
      }).join(';')

      if (!dots) return []

      if (w > 560) {
        this.planerOptions.x_spacing = 3
        this.planerOptions.y_spacing = 3
        this.planerOptions.padding = 3
      } else {
        this.planerOptions.x_spacing = 2
        this.planerOptions.y_spacing = 2
        this.planerOptions.padding = 2
      }
      this.dotsReq = `w=${w.toString()}&h=${h.toString()}&dots=${dots}&width=${w > 560 ? 150 : Math.ceil((w - (this.planerOptions.padding * 2) - (this.planerOptions.x_spacing * 2) - 5) / 3)}&x_spacing=${this.planerOptions.x_spacing}&y_spacing=${this.planerOptions.y_spacing}&padding=${this.planerOptions.padding}&mode=${this.planerOptions.mode}`
      return this.$axios.get(`/planner/json/?${this.dotsReq}`).then(({ data }) => {
        let topY = 0, bottomY = 0;

        data.forEach(item => {
          bottomY = Math.min(item.snoska.center[1] - 25, bottomY)
          topY = Math.max((item.snoska.center[1] - h) + 25, topY)
        })

        this.topOffset = Math.abs(topY) > 0 ? Math.abs(topY) + 10 : 0
        this.bottomOffset = (Math.abs(bottomY) > 0 ? Math.abs(bottomY) + 10 : 0) + this.labelHeight

        return data.map(x => {
          const renderDotInfo = JSON.parse(JSON.stringify(this.getObjectForPlanned(anchors.get(`${x.dot[0]}x${x.dot[1]}`))))
          x.object = renderDotInfo.object || {}

          if (x.object.properties) {
            x.object.properties.forEach(t => {
              t.propHumanReadableValue = humanReadablePropValue(t, this.$store.getters['objects/cachedObjectsGetter'], { reverseFullObject: false }).map(x => x.filter(i => i).join(', ')).join(', ')
              t.renderCollectIcon = computeRenderIconOfProp(t)
            })
          }
          x.id = renderDotInfo.id
          x.startPos = x.snoska.center[0] - (x.snoska.wh[0] / 2)
          x.markerPos = Math.max(x.line[x.line.length - 1][0] - x.startPos, 0)
          let markerOffset = 0
          if (x.snoska.wh[0] > 149 && x.markerPos < 25) {
            /* Добавление смещения точке по радиусу скругления */
            let R = 25
            markerOffset = Math.abs(R - ((R - x.markerPos) * Math.tan(Math.acos((R - x.markerPos) / R))))
            markerOffset = Math.max(markerOffset - 2, 0)
          }

          x.markerTop = x.snoska.center[1] > 0 ? 'unset' : `${markerOffset}px`
          x.markerBottom = x.snoska.center[1] < 0 ? 'unset' : `${(markerOffset)}px`
          return x
        })
      })
    },
    drawLines() {
      if (!this.plannerLayer) {
        this.plannerLayer = this.createLayer()
        this.stage.add(this.plannerLayer)
      } else {
        this.plannerLayer.removeChildren()
      }
      this.plannerLayer.setAttr('id', 'planner')
      const scale = this.getStageScale()
      const h = Math.ceil(this.sceneHeight * scale)

      this.planner.forEach(x => {
        const line = new Konva.Line({
          points: x.line.map(x => {
            return [x[0] / scale, (h - x[1]) / scale + this.topOffset / scale]
          }).flat(),
          stroke: '#328FE6',
          strokeWidth: 1,
          lineCap: 'round',
          lineJoin: 'round',
        })
        const outline = new Konva.Line({
          points: x.line.map(x => {
            return [x[0] / scale, (h - x[1]) / scale + this.topOffset / scale]
          }).flat(),
          stroke: 'white',
          strokeWidth: 3,
          lineCap: 'round',
          lineJoin: 'round',
          opacity: .2
        })
        this.plannerLayer.add(outline, line)
      })
      this.plannerLayer.draw()
    },
    getObjectForPlanned(coords) {
      return this.renderDots.find(x => x.plannerCenter === coords)
    },
    getViewPortSize() {
      const scale = this.getStageScale()
      return {
        scene: {
          height: Math.ceil(this.sceneWidth / this.data.polygons.aspectRatio),
          width: this.sceneWidth
        },
        render: {}
      }
    },
    // Фон холста
    generatePoints(width, height, count) {
      const points = [];

      for (let i = 0; i < count; i++) {
        points.push([Math.random() * width, Math.random() * height]);
      }
      return { points, width, height };
    },
    generateVoronoiMosaic({ points, width, height }, offset) {
      /*const width = this.stage.width() / this.getStageScale();
      const height = this.stage.height() / this.getStageScale();*/
      const delaunay = this.$delaunay.from(points);
      const voronoi = delaunay.voronoi([0, 0, width, height]);
      const res = []

      for (let i = 0; i < points.length; i++) {
        const cell = voronoi.cellPolygon(i);

        if (cell) {
          res.push(new Konva.Line({
            points: cell.map(x => [x[0], x[1] + offset]).flat(),
            fill: `hsl(0, 0%, ${20 + Math.random() * 50}%)`,
            closed: true,
            opacity: .15,
            listening: false
          }))
        }
      }
      return res
    },
    drawBackground(noDraw = false, topOffset = this.topOffset, bottomOffset = this.bottomOffset, stage = this.stage) {
      if (!topOffset && !bottomOffset) return
      console.time('Total');
      let layer = null

      if (!noDraw) {
        layer = this.backgroundLayer
        if (!layer) {
          layer = new Konva.Layer({ listening: false })
          this.stage.add(layer)
          layer.moveToBottom()
        } else {
          layer.removeChildren()
        }
      } else {
        layer = new Konva.Layer({ listening: false })
      }
      layer.setAttrs({ 'opacity': .5, id: 'voronoy' })
      const imageObj = new Image();
      imageObj.src = this.imageData;
      const imgScale = this.sceneWidth / this.data.polygons.coordinates.width;
      const stageScale = this.getStageScale()
      const originHeight = this.data.polygons.coordinates.height

      const scale = ((originHeight * imgScale) + ((topOffset + bottomOffset) / stageScale)) / (originHeight * imgScale);

      layer.add(new Konva.Rect({
        x: 0,
        y: 0,
        fill: 'white',
        opacity: 1,
        width: this.data.polygons.coordinates.width * scale,
        height: this.data.polygons.coordinates.height * scale,
        scaleX: imgScale,
        scaleY: imgScale
      }))
      // const image = new Konva.Image({
      //   image: imageObj,
      //   x: (this.data.polygons.coordinates.width * (1 - scale) / 2) * imgScale,
      //   y: 0,
      //   width: this.data.polygons.coordinates.width * scale,
      //   height: this.data.polygons.coordinates.height * scale,
      //   type: 'image',
      //   preventDefault: false,
      //   opacity: .6,
      //   scaleX: imgScale,
      //   scaleY: imgScale
      // });

      // layer.add(image)

      layer.add(new Konva.Rect({
        x: 0,
        y: 0,
        fill: 'white',
        opacity: .3,
        width: this.data.polygons.coordinates.width * scale,
        height: this.data.polygons.coordinates.height * scale,
        scaleX: imgScale,
        scaleY: imgScale
      }))
      console.time('points');
      const sceneHeight = stage.height() / this.getStageScale()

      const topPoints = this.generatePoints(stage.width() / this.getStageScale(), topOffset / this.getStageScale(), 150);
      const bottomPoints = this.generatePoints(stage.width() / this.getStageScale(), bottomOffset / this.getStageScale(), 150);

      console.timeEnd('points');
      console.time('polygons');
      layer.add(
        ...this.generateVoronoiMosaic(topPoints, 0),
        ...this.generateVoronoiMosaic(bottomPoints, sceneHeight - (bottomOffset / this.getStageScale()))
      )

      console.timeEnd('polygons');
      console.time('layer');
      if (!noDraw) layer.draw()
      console.timeEnd('layer');

      console.timeEnd('Total');

      return layer
    },
    createScreenShot() {
      const isCustomDesign = this.$auth?.user?.profile?.use_own_style
      const infographicStyles = this.$auth?.user?.profile?.infographic_styles

      return new Promise((resolve, reject) => {
        import("dom-to-image")
          .then(async ({ default: domtoimage }) => {
            function filter(node) {
              try {
                return !node.hasAttribute('data-html2canvas-ignore') && node.tagName !== "CANVAS";
              } catch (e) {
                return true
              }
            }

            const element = this.$refs["canvas-container"]
            const scale = 2

            Promise.all([

              new Promise(async (resolve, reject) => {
                return domtoimage.toPng(element, {
                  width: element.clientWidth * scale,
                  height: element.clientHeight * scale,
                  style: {
                    transform: "scale(" + scale + ")",
                    transformOrigin: "top left"
                  },
                  filter: filter
                })
                  .then(dataUrl => {
                    return Konva.Image.fromURL(dataUrl, async (image) => {
                      const width = Math.ceil(image.width() / 2)
                      const height = Math.ceil(image.height() / 2)
                      let heightWithoutLabel = height
                      try {
                        heightWithoutLabel = Math.ceil(height - this.labelHeight)
                      } catch (e) {
                        console.warn('fail compute height')
                      }

                      const group = new Konva.Group({
                        width: width,
                        height: heightWithoutLabel,
                        clip: {
                          x: 0,
                          y: 0,
                          width: width,
                          height: heightWithoutLabel
                        }
                      });
                      image.setAttrs({
                        width: width,
                        height: height,
                      })
                      group.add(image)

                      const bg = await new Promise((r) => {
                        this.stage.toImage({
                          mimeType: 'image/png',
                          width: width,
                          height: heightWithoutLabel,
                          callback: (img) => {
                            r(new Konva.Image({ image: img }))
                          }
                        })
                      })
                      group.add(bg)
                      bg.moveToBottom()
                      resolve(group)
                    })
                  })
                  .catch(err => reject(err))
              }),
              new Promise((resolve, reject) => {
                const logoCollectionID = isCustomDesign && infographicStyles?.nameAndLogo?.logoCollectionID;
                const userIcon = this.$auth.user?.profile?.icon;
                if (isCustomDesign && logoCollectionID) {
                  return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${logoCollectionID}/picto_white/`), (image) => resolve(image), (error) => reject(error))
                } else if (isCustomDesign && userIcon) {
                  return Konva.Image.fromURL(addServerPath(`/admin/icon_files/${userIcon}/picto_white/`), (image) => resolve(image), (error) => reject(error))
                } else {
                  return Konva.Image.fromURL(require(`~/assets/img/logo-vistat${!isCustomDesign ? '-white' : ''}.png`), (image) => resolve(image), (error) => reject(error))
                }
              }),
              (
                isCustomDesign && (infographicStyles?.background?.collectionID || infographicStyles?.background?.bgID) ?
                  new Promise(async (resolve, reject) => {
                    if (infographicStyles?.background?.collectionID) {
                      const response = await store.dispatch('backgrounds/fetchPublicObject', infographicStyles?.background?.collectionID)
                      return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                    } else if (infographicStyles?.background?.bgID) {
                      return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(infographicStyles?.background?.bgID), (image) => resolve(image), (error) => reject(error))
                    }
                  })
                  : null
              ),
              (
                isCustomDesign && (infographicStyles?.nameAndLogo?.bgCollectionID || infographicStyles?.nameAndLogo?.bgID) ?
                  new Promise(async (resolve, reject) => {
                    if (infographicStyles?.nameAndLogo?.bgCollectionID) {
                      const response = await store.dispatch('backgrounds/fetchPublicObject', infographicStyles?.nameAndLogo?.bgCollectionID)
                      return Konva.Image.fromURL(addServerPath(`${STORAGE_BACKGROUND_PATH}${response.picto}`), (image) => resolve(image), (error) => reject(error))
                    } else if (infographicStyles?.nameAndLogo?.bgID) {
                      return Konva.Image.fromURL(BUILD_GENERAL_STORAGE_IMAGE_PATH(infographicStyles?.nameAndLogo?.bgID), (image) => resolve(image), (error) => reject(error))
                    }
                  })
                  : null
              ),
              new Promise(async (resolve, reject) => {
                fetch(require(`~/assets/svg/info-italic.svg`))
                  .then((response) => response.text())
                  .then((infoSvg) => {
                    const coloredSvg = infoSvg.replace(/fill="[^"]*"/g, `fill="${infographicStyles?.nameAndLogo?.color ?? '#687782'}"`);
                    const blob = new Blob([coloredSvg], { type: 'image/svg+xml' });
                    const url = URL.createObjectURL(blob);

                    return Konva.Image.fromURL(url, (image) => resolve(image), (error) => reject(error))
                  })
              }),
            ])
              .then((results) => {
                const background = results[0]
                const logo = results[1]
                const blockBackground = results[2]
                const nameBackground = results[3]
                const infoIcon = results[4]

                const offscreenCanvas = document.createElement('canvas');
                offscreenCanvas.width = background.width();
                offscreenCanvas.height = background.height();

                const stage = new Konva.Stage({
                  width: background.width(),
                  height: background.height(),
                  container: offscreenCanvas,
                })

                const header = new Konva.Text({
                  width: stage.width() - 180,
                  y: 10,
                  x: 20,
                  text: this.title,
                  fontSize: isCustomDesign ? infographicStyles?.nameAndLogo?.nameFontSize : 28,
                  fontFamily: 'Formular',
                  lineHeight: 1.2,
                  weight: 700,
                  fill: isCustomDesign ? (infographicStyles?.nameAndLogo?.color ?? '#687782') : '#fff',
                  align: 'center'
                })
                let subheader = null

                if (this.data.label) {
                  subheader = new Konva.Text({
                    width: stage.width() - 180,
                    y: header.height() + 10,
                    x: 20,
                    text: this.data.label,
                    fontSize: isCustomDesign ? infographicStyles?.nameAndLogo?.nameFontSize : 16,
                    fontFamily: 'Formular',
                    lineHeight: 1.2,
                    fill: isCustomDesign ? (infographicStyles?.nameAndLogo?.color ?? '#687782') : '#fff',
                    weight: 300,
                    align: 'center'
                  })
                }

                const logoGroup = new Konva.Group({
                  width: 140,
                  y: 10,
                  x: stage.width() - 150,
                })

                let author
                if (isCustomDesign && infographicStyles?.nameAndLogo?.showName) {
                  author = new Konva.Text({
                    width: logoGroup.width(),
                    text: this.$auth.user.profile?.nickname || this.$auth.user.username,
                    fontSize: infographicStyles?.nameAndLogo?.fontSize,
                    fontFamily: 'Formular',
                    lineHeight: 1.2,
                    weight: 700,
                    fill: infographicStyles?.nameAndLogo?.color ?? '#687782',
                    align: 'center'
                  })
                  logoGroup.add(author)
                }

                const logoAspectRatio = logo.width() / logo.height();
                if (isCustomDesign) {
                  const logoWidth = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(0, 2))
                  const logoHeight = Number(infographicStyles?.nameAndLogo?.logoSize?.slice(3, 5))
                  const targetAspectRatio = logoWidth / logoHeight;

                  if (logoAspectRatio > targetAspectRatio) {
                    // Логотип шире контейнера — масштабируем по ширине
                    logo.width(logoWidth);
                    logo.height(logoWidth / logoAspectRatio);
                  } else {
                    // Логотип выше контейнера — масштабируем по высоте
                    logo.height(logoHeight);
                    logo.width(logoHeight * logoAspectRatio);
                  }
                } else {
                  if (logoAspectRatio >= 1) {
                    // Если ширина по пропорциям >= 1 масштабируем по высоте
                    logo.width(logoGroup.width() / 2);
                    logo.height(logoGroup.width() / 2 / logoAspectRatio);
                  } else {
                    // Если контейнер выше, масштабируем по ширине
                    logo.width(logoGroup.width() / 2);
                    logo.height(logoGroup.width() / 2 * logoAspectRatio);
                  }
                }

                const textHeight = 10 + header.height() + 10 + (subheader ? subheader.height() + 10 : 0)

                // Центрируем логотип внутри группы
                logo.x((logoGroup.width() - logo.width()) / 2);
                if (isCustomDesign && infographicStyles?.nameAndLogo?.showName) {
                  logo.y(author.height() + 5);
                  logoGroup.height(author.height() + logo.height() + 5)
                } else {
                  // logoGroup.y((textHeight - logo.height()) / 2)
                  // logoGroup.y(textHeight / 2 - logo.height() / 2)
                  logoGroup.height(logo.height())
                }

                logoGroup.add(logo)

                const headerGroup = new Konva.Group({
                  width: stage.width(),
                  height: Math.max(textHeight, logoGroup.height() + 20),
                  clip: {
                    x: 0,
                    y: 0,
                    width: stage.width(),
                    height: Math.max(textHeight, logoGroup.height() + 20)
                  }
                })

                let footer;
                let footerGroup;
                if (isCustomDesign) {
                  footer = new Konva.Text({
                    width: stage.width(),
                    y: 10,
                    x: 22,
                    text: 'Создано с помощью vistat.org',
                    fontSize: 12,
                    fontFamily: 'Formular',
                    lineHeight: 1.2,
                    weight: 700,
                    fill: infographicStyles?.nameAndLogo?.color ?? '#687782',
                    align: 'left'
                  })

                  infoIcon.setAttrs({ x: 0, y: 8, width: 16, height: 16 })

                  footerGroup = new Konva.Group({
                    width: stage.width(),
                    height: 34,
                    y: headerGroup.height() + background.height(),
                    clip: {
                      x: 0,
                      y: 0,
                      width: stage.width(),
                      height: 34
                    }
                  })
                }

                if (nameBackground && (infographicStyles?.nameAndLogo?.type === 'image' || infographicStyles?.nameAndLogo?.type === 'bg-image')) {
                  const nameBackground2 = cloneDeep(nameBackground)
                  const nameAndLogoOpacity = (infographicStyles?.nameAndLogo?.opacity || infographicStyles?.nameAndLogo?.opacity === 0)
                    ? infographicStyles?.nameAndLogo?.opacity / 100
                    : 1;

                  nameBackground.setAttrs({
                    opacity: nameAndLogoOpacity
                  });
                  nameBackground2.setAttrs({
                    opacity: nameAndLogoOpacity
                  });

                  // Сохранение пропорций
                  const nameRatio = nameBackground.width() / nameBackground.height();
                  const headerRatio = headerGroup.width() / headerGroup.height()
                  const footerRatio = footerGroup.width() / footerGroup.height()

                  if (headerRatio > nameRatio) {
                    nameBackground.width(headerGroup.width());
                    nameBackground.height(headerGroup.width() / nameRatio);
                  } else {
                    nameBackground.width(headerGroup.height() * nameRatio);
                    nameBackground.height(headerGroup.height());
                  }

                  // Центрируем nameBackground внутри headerGroup
                  nameBackground.x((headerGroup.width() - nameBackground.width()) / 2);
                  nameBackground.y((headerGroup.height() - nameBackground.height()) / 2);

                  headerGroup.add(nameBackground);
                  nameBackground.moveToBottom();

                  if (footerRatio > nameRatio) {
                    nameBackground2.width(footerGroup.width());
                    nameBackground2.height(footerGroup.width() / nameRatio);
                  } else {
                    nameBackground2.width(footerGroup.height() * nameRatio);
                    nameBackground2.height(footerGroup.height());
                  }

                  // Центрируем nameBackground2 внутри footerGroup
                  nameBackground2.x((footerGroup.width() - nameBackground2.width()) / 2);
                  nameBackground2.y((footerGroup.height() - nameBackground2.height()) / 2);

                  footerGroup.add(nameBackground2);
                  nameBackground2.moveToBottom();
                }


                if (textHeight < headerGroup.height()) {
                  [header, subheader].filter(x => x !== null).forEach((node) => {
                    node.setAttrs({
                      y: Math.ceil(node.y() + (headerGroup.height() - textHeight - 10) / 2)
                    })
                  })
                }

                const calcedOpacity = (infographicStyles?.nameAndLogo?.opacity || infographicStyles?.nameAndLogo?.opacity === 0) ? infographicStyles?.nameAndLogo?.opacity / 100 : 1
                const groupFill = !infographicStyles?.nameAndLogo?.bgColor || infographicStyles?.nameAndLogo?.type !== 'color' ? 'rgba(255,255,255,0)'
                  : `rgba(${hexToRgb(infographicStyles?.nameAndLogo?.bgColor)}, ${calcedOpacity})`

                if (isCustomDesign && !nameBackground) {
                  headerGroup.add(
                    new Konva.Rect({
                      width: stage.width(),
                      height: headerGroup.height(),
                      fill: groupFill,
                    }),
                  )
                } else if (!isCustomDesign) {
                  headerGroup.add(
                    new Konva.Rect({
                      width: stage.width(),
                      height: headerGroup.height(),
                      fill: '#328FE6',
                    }),
                  )
                }
                headerGroup.add(
                  header,
                  logoGroup
                )
                if (subheader) headerGroup.add(subheader)

                const content = new Konva.Layer()

                if (isCustomDesign) {
                  footerGroup.add(
                    new Konva.Rect({
                      width: stage.width(),
                      height: footerGroup.height(),
                      fill: groupFill,
                    }),
                    footer,
                    infoIcon
                  )
                  footerGroup.moveToBottom()

                  background.y(headerGroup.height())
                  content.add(headerGroup, background, footerGroup)
                  stage.height(stage.height() + headerGroup.height() + footerGroup.height())
                } else {
                  background.y(headerGroup.height())
                  content.add(headerGroup, background)
                  stage.height(stage.height() + headerGroup.height())
                }

                // Добавляем обводку
                stage.height(stage.height() + 16)
                stage.width(stage.width() + 16)

                content.children.forEach(node => {
                  node.x(node.x() + 8)
                  node.y(node.y() + 8)
                })

                const bg = new Konva.Group({
                  width: stage.width(),
                  height: stage.height(),
                })

                bg.add(new Konva.Rect({
                  x: 0,
                  y: 0,
                  width: stage.width(),
                  height: stage.height(),
                  fill: infographicStyles?.background?.opacity === 0 ? 'rgba(255,255,255,1)' : `rgba(${hexToRgb(infographicStyles?.background?.color ?? '#ffffff')}, ${(infographicStyles?.background?.opacity || infographicStyles?.background?.opacity === 0) ? infographicStyles?.background?.opacity / 100 : 1})`,
                }))

                const borders = {
                  solid: [], // "⸻"
                  dot: [2, 6], // "· · · · ·"
                  shortdash: [10, 5], // "------"
                  dash: [15, 10], // "‒ ‒ ‒"
                  longdash: [25, 15], // "— — —"
                  // dashdot: [15, 5, 5, 5], // "Длинное тире - короткое тире"
                  // longdashdot: [30, 10, 2, 10], // "Очень длинное тире - точка"
                  // longdashdotdot: [15, 5, 2, 3, 2, 5], // "Длинное тире - точка-точка"
                  shortdashdot: [10, 5, 2, 5], // "Тире-точка"
                  shortdashdotdot: [10, 5, 2, 3, 2, 5], // "Тире-точка-точка"
                  // shortdot: [2, 8], // "Точки через двойной интервал"
                }

                if (blockBackground) {
                  const blockOpacity = (infographicStyles?.background?.opacity || infographicStyles?.background?.opacity === 0)
                    ? infographicStyles?.background?.opacity / 100
                    : 1;
                  blockBackground.setAttrs({
                    width: stage.width(),
                    height: stage.height(),
                    opacity: blockOpacity
                  });
                  // blockBackground.moveToBottom();
                  // фон
                  bg.add(blockBackground)
                }

                if (isCustomDesign && infographicStyles?.border?.line !== 'none') {
                  bg.add(
                    // Фон
                    // new Konva.Rect({
                    //   width: bg.width(),
                    //   height: bg.height(),
                    //   fill: '#fff'
                    // }),
                    new Konva.Rect({
                      stroke: infographicStyles?.border?.color ?? '#328FE6',
                      strokeWidth: infographicStyles?.border?.lineWidth ?? 2,
                      dash: borders[infographicStyles?.border?.line],
                      fill: `rgba(0,0,0,0)`,
                      x: 4,
                      y: 4,
                      width: bg.width() - 8,
                      height: bg.height() - 8,
                      ...(infographicStyles?.border?.shadow ? {
                        shadowColor: infographicStyles?.border?.color ?? '#ffffff',
                        shadowBlur: 10,
                        shadowOffset: { x: 0, y: 0 },
                        shadowOpacity: (infographicStyles?.border?.opacity || infographicStyles?.border?.opacity === 0) ? infographicStyles?.border?.opacity : 1,
                      } : {})
                    })
                  )
                } else if (!isCustomDesign) {
                  bg.add(
                    // Фон
                    new Konva.Rect({
                      width: bg.width(),
                      height: bg.height(),
                      fill: '#fff'
                    }),
                    new Konva.Rect({
                      stroke: '#328FE6',
                      strokeWidth: 2,
                      x: 4,
                      y: 4,
                      width: bg.width() - 8,
                      height: bg.height() - 8,
                    })
                  )
                }

                content.add(bg)
                bg.moveToBottom()

                const whiteBg = new Konva.Rect({
                  width: stage.width(),
                  height: stage.height(),
                  x: 0,
                  y: 0,
                  fill: 'white'
                })
                content.add(whiteBg)
                whiteBg.setZIndex(0)

                stage.add(content)

                stage.draw()

                const link = document.createElement('a');
                link.href = stage.toDataURL({ mimeType: 'image/jpeg', pixelRatio: 2, quality: .9 });
                let title = this.title
                if (this.data.label) {
                  title = `${title}_${this.data.label}`
                }
                link.download = `${title}.jpeg`;
                link.click();

                stage.destroy()

                resolve()
              })
              .catch(error => reject(error))
          })
          .catch(error => reject(error))
      })
    },
    snoskaFocusInHandler(id) {
      if (window.innerWidth < 700) return
      const LINE_PATH = this.polygonsLayer.findOne(`#${id}`);
      LINE_PATH.setAttr('opacity', 1)
    },
    snoskaFocusOutHandler(id) {
      if (window.innerWidth < 700) return
      const LINE_PATH = this.polygonsLayer.findOne(`#${id}`);
      if (!LINE_PATH.getAttr('opened')) LINE_PATH.setAttr('opacity', 0)
    },
  },
}
